import { render, staticRenderFns } from "./SignInFormCpf.vue?vue&type=template&id=49e67ef4&scoped=true"
import script from "./SignInFormCpf.vue?vue&type=script&lang=js"
export * from "./SignInFormCpf.vue?vue&type=script&lang=js"
import style0 from "./SignInFormCpf.vue?vue&type=style&index=0&id=49e67ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e67ef4",
  null
  
)

export default component.exports